import { render, staticRenderFns } from "./restBookSummarySetShopDeliver_v2.vue?vue&type=template&id=4b16768a&scoped=true&"
import script from "./restBookSummarySetShopDeliver_v2.vue?vue&type=script&lang=js&"
export * from "./restBookSummarySetShopDeliver_v2.vue?vue&type=script&lang=js&"
import style0 from "./restBookSummarySetShopDeliver_v2.vue?vue&type=style&index=0&id=4b16768a&prod&lang=scss&"
import style1 from "./restBookSummarySetShopDeliver_v2.vue?vue&type=style&index=1&id=4b16768a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16768a",
  null
  
)

export default component.exports